import IconButton from '../IconButton'
import ReplyIcon from 'ui-component-library/icons/reply.svg'

type Props = {
  onClick: () => void
  children: string
}

function ReplyButton({ onClick, children }: Props) {
  return (
    <IconButton Icon={ReplyIcon} onClick={onClick}>
      {children}
    </IconButton>
  )
}

export default ReplyButton
